@if (loading()) {
  <p class="p-4 text-sm text-gray-500" data-cy="agent-history-loading">{{ 'common.loading' | translate }}</p>
} @else if (!conversations().length) {
  <p class="p-4 text-sm text-gray-500" data-cy="agent-history-empty">
    {{ 'agent-chat.history-empty' | translate }}
  </p>
} @else {
  <ul class="divide-y divide-gray-100" data-cy="agent-history">
    @for (conversation of conversations(); track conversation._id) {
      <li>
        <button
          type="button"
          class="flex w-full items-start gap-2 px-4 py-3 text-left hover:bg-gray-50"
          data-cy="agent-history-item"
          (click)="selected.emit(conversation._id)"
        >
          <span class="flex min-w-0 grow flex-col">
            <span class="truncate text-sm" [class.font-semibold]="conversation.unread">{{ conversation.title }}</span>
            <span class="text-xs text-gray-500">{{ dateOf(conversation.updatedAt) }}</span>
          </span>
          @if (conversation.unread) {
            <span class="mt-1 rounded-full bg-brand-600 px-2 py-0.5 text-xs text-white" data-cy="agent-history-unread">
              {{ 'agent-chat.unread' | translate }}
            </span>
          }
        </button>
      </li>
    }
  </ul>
}
